import { createContext, PropsWithChildren, useCallback, useContext, useRef, useState } from 'react';
import { Scripts } from 'scbk-services';
import { useAstxIsInstall } from '../hooks/useAstxIsInstall';

const baseUrl = window.location.origin;
console.log('### baseUrl : ', baseUrl);
const astxScripts = [
  // {
  //   id: 'astx2',
  //   src: `${baseUrl}resource/product/ahnlab/astx2.js`,
  // },
  {
    id: 'astx2-custom',
    src: `${baseUrl}/resource/product/ahnlab/astx2_custom.js`,
  },
  {
    id: 'astx2-min',
    src: `${baseUrl}/resource/product/ahnlab/astx2.min.js`,
  },
];

/**
 * astx keypad 컨텍스트 Props
 */
interface AstxContextProps {
  isInstalled: boolean;
}

/**
 * astx keypad 컨텍스트 생성
 */
const AstxContext = createContext<AstxContextProps>({
  isInstalled: false,
});

/**
 * 채널 컨텍스트 hook
 * @returns
 */
const useAstxContext = () => {
  const context = useContext(AstxContext);
  return context;
};

/**
 *
 * @param param0
 * @returns
 */
const AstxKeypadProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [ready, setReady] = useState(false);
  const { astxIsInstall } = useAstxIsInstall();

  const astxInstalledRef = useRef<boolean>(false);

  const init = () => {
    window.$ASTX2_CUST.getURL = (type: string) => {
      console.log('### override 성공');

      let result = '';

      let url = window.location.protocol + '//' + window.location.hostname;

      url += window.location.port ? ':' + window.location.port : '';

      switch (type) {
        case window.$ASTX2_CUST.URL_GET_INIT:
          result = url + '/bsoi/commons/doGetInit';
          break;
        case window.$ASTX2_CUST.URL_GET_CERT:
          result = url + '/bsoi/commons/doGetCert';
          break;
      } // end of switch

      return result;
    };
  };

  const isInstallCheck = useCallback(async () => {
    let installed = await astxIsInstall(true);
    console.log('### driver installed : ', installed);
    astxInstalledRef.current = installed === '' ? false : installed;
    setReady(true);
  }, [astxIsInstall]);

  if (!ready) {
    return (
      <>
        <Scripts
          scripts={astxScripts}
          strategy="afterInteractive"
          onReady={async () => {
            await init();
            await isInstallCheck();
          }}
          onError={(e: Error) => {
            console.error('[AstxKeypadProvider] nfilter load failed', e);
          }}
        />
      </>
    );
  }
  return (
    <AstxContext.Provider value={{ isInstalled: astxInstalledRef.current }}>
      {children}
    </AstxContext.Provider>
  );
};

export { AstxKeypadProvider, useAstxContext };
